import { ReactNode } from "react";
import styles from "../aic.module.css";
import { AitHeaderOptionsWindow } from "./AitHeaderOptionsWindow";
import { AitRowGroupOptionsButton } from "./AitRowGroupOptionsButton";
import { AitRowGroupTrafficLight } from "./AitRowGroupTrafficLight";
import { AitLocationHeaderRow, AitTablePosition } from "./functions/interface";

interface AitHeaderRowFirstCellProps {
  location: AitLocationHeaderRow;
}

/**
 * Render the first cell for a header row which contains group controls.
 *
 * @param props - Component props
 * @param props.location - The header row location
 */
export const AitHeaderRowFirstCell = ({ location }: AitHeaderRowFirstCellProps): ReactNode => (
  <td
    className={styles.aitCell}
    width="50px"
  >
    {location.row === 0 && (
      <AitRowGroupTrafficLight location={{ ...location, position: AitTablePosition.header }} />
    )}
    <div className={[styles.aitAieHolder, styles.aitRowGroupButtons, styles.flexRowEnd].join(" ")}>
      {location.row === 0 && (
        <>
          <AitRowGroupOptionsButton
            location={{
              position: AitTablePosition.header,
              tableSection: location.tableSection,
              rowGroup: location.rowGroup,
              rowGroupId: location.rowGroupId,
            }}
          />
          <AitHeaderOptionsWindow />
        </>
      )}
    </div>
  </td>
);

AitHeaderRowFirstCell.displayName = "AitHeaderRowFirstCell";
